<template>
	<div class="main">
		<hwk-header type="user"></hwk-header>
		<div class="warp hwk-user">
			<hwk-left type="user"></hwk-left>
			<div class="user-right">
				<div class="u-title">
					个人信息
				</div>
				<div class="u-form">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="头像">
							<div class="avatar" v-if="edit" @click="upload">
								<input type="file" ref="imgInput" @change="handleImgUpload" style="display: none"
									:multiple="false" />
								<img :src="http+form.avatar" alt="" />
								<div class="f">
									<img src="@/assets/frame.png" alt="" />
								</div>
							</div>
							<div class="avatar" v-else>
								<img :src="http+form.avatar" alt="" v-if="form.avatar" />
								<img src="@/assets/avatar.png" alt="" v-else />
							</div>
						</el-form-item>
						<el-form-item label="昵称">
							<el-input v-model="form.nickname" :disabled="!edit"></el-input>
						</el-form-item>
						<!-- 是否认证:0=否,1=个人认证,2=企业认证	 -->
						<el-form-item label="认证">
							<div class="rz flex" style="padding-top: 8px;">
								<div class="rz2 flex pointer" v-if="form.is_attestation == 1" @click="pageTo('auth')">
									<img src="@/assets/rz1.png" alt="" />
									<span>个人</span>
								</div>
								<div class="rz2 flex pointer" v-if="form.is_attestation == 2" @click="pageTo('auth')">
									<img src="@/assets/qy.png" alt="" />
									<span>企业</span>
								</div>

								<div class="rz1 flex" v-if="form.is_attestation == 0">
									<img src="@/assets/rz1.png" alt="" />
									<span>未认证</span>
								</div>
								<div class="rz0" v-if="form.is_attestation == 0" @click="pageTo('auth')">
									去认证>>
								</div>
							</div>
						</el-form-item>
						<div class="u-title">
							登录与安全
						</div>
						<el-form-item label="用户名">
							<el-input v-model="form.username" placeholder="请输入用户名" :disabled="!edit"></el-input>
						</el-form-item>
						<el-form-item label="手机号">
							<el-input v-model="form.mobile" placeholder="请输入手机号" :disabled="!edit"></el-input>
						</el-form-item>
						<!-- <el-form-item label="邮箱">
							<el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
						</el-form-item> -->
						<el-form-item label="密码">
							<el-input v-model="form.password" placeholder="请输入密码" show-password
								:disabled="!edit"></el-input>
						</el-form-item>

						<el-form-item v-if="edit">
							<div class="btns flex">
								<div class="u-btn1 pointer" @click="edit = false">取消修改</div>
								<div class="u-btn2 pointer" @click="submit">保存</div>
							</div>
						</el-form-item>
						<el-form-item v-else>
							<div class="u-btn1 pointer" @click="edit = true">修改资料</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
		</div>
		<navigation :usershow='false'></navigation>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import hwkLeft from './hwk-left.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation,
			hwkLeft
		},
		data() {
			return {
				http: this.$imgUrl,
				edit: false,
				form: {
					avatar: "",
					is_attestation: "",
					mobile: "",
					nickname: "",
					// email: "",
					username: ""
				}
			};
		},
		created() {
			this.getUserInfo();
		},
		methods: {
			handleImgUpload(event) {
				console.log(event, '---------')
				const file = event.target.files[0];
				const isJPG = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4'].includes(file.type);
				const isLt2M = file.size / 1024 / 1024 < 5;
				if (!isJPG) {
					this.$message.error('只能上传图片/视频格式!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片/视频大小不能超过 5MB!');
					return
				}
				const formData = new FormData();
				formData.append('file', file);
				this.$http.post('/api/common/upload', formData, {
					headers: {
						'Content-Type': 'multipart/form-data',
						'token': localStorage.getItem('token')
					}
				}).then(response => {
					console.log('上传成功:', response.data);
					this.form.avatar = response.data.url
				}).catch(error => {
					console.error('上传失败:', error);
				});

			},
			upload() {
				this.$refs.imgInput.click()
			},
			submit() {
				// if (!this.form.avatar) {
				// 	this.$message({
				// 		message: '头像不能为空',
				// 		type: 'warning'
				// 	});
				// 	return
				// }
				if (!this.form.nickname) {
					this.$message({
						message: '昵称不能为空',
						type: 'warning'
					});
					return
				}
				if (!this.form.username) {
					this.$message({
						message: '用户名不能为空',
						type: 'warning'
					});
					return
				}
				if (!this.form.mobile) {
					this.$message({
						message: '手机号不能为空',
						type: 'warning'
					});
					return
				}
				if (this.form.mobile && !isValidPhoneNumber(this.form.mobile)) {
					this.$message({
						message: '手机号格式错误',
						type: 'warning'
					});
					return
				}

				function isValidPhoneNumber(phoneNumber) {
					// 正则表达式，匹配中国大陆手机号
					const phoneRegex = /^1[3-9]\d{9}$/;
					return phoneRegex.test(phoneNumber);
				}
				// if (!this.form.email) {
				// 	this.$message({
				// 		message: '邮箱不能为空',
				// 		type: 'warning'
				// 	});
				// 	return
				// }
				// if (!this.form.password) {
				// 	this.$message({
				// 		message: '密码不能为空',
				// 		type: 'warning'
				// 	});
				// 	return
				// }

				this.$http.post('/api/user/profile', {
					avatar: this.form.avatar,
					nickname: this.form.nickname,
					mobile: this.form.mobile,
					password: this.form.password,
					// email: this.form.email,
					username: this.form.username,
				}).then(res => {
					if (res.code == 1) {
						this.$message({
							message: '修改成功',
							type: 'success'
						});
						this.edit = false
						this.getUserInfo()
					} else {
						this.$message({
							message: res.msg,
							type: 'warning'
						});
					}

				});

			},
			getUserInfo() {
				this.$http.get('/api/user/index', {
					params: {

					}

				}).then(res => {

					let user = res.data.user
					this.form = res.data.user
					let nickname = res.data.user.nickname
					localStorage.setItem('nickname', nickname);
					localStorage.setItem('userinfo', JSON.stringify(res.data.user));
					this.$store.dispatch('setUserInfo', res.data.user);
					console.log(this.form)
				});
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			toDetails(id) {
				// this.$router.push({
				// 	path: `/details/${id}`
				// });
				// this.$router.push({
				// 	name: "details",
				// 	params: {
				// 		id: id
				// 	}
				// });
				this.$router.push({
					path: "/details",
					query: {
						id: id
					}
				});
			},

		},
	};
</script>
<style lang="less" scoped>
	@color1: #11192D;
	@color2: #FF6A00;

	.hwk-user {
		margin: 20px auto;
		padding: 20px;
		border-radius: 10px;
		background-color: #fff;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;

		.u-btn1 {
			width: 248px;
			height: 48px;
			background: #FFFFFF;
			border-radius: 10px;
			text-align: center;
			border: 1px solid #D8D8D8;
			line-height: 48px;
			color: #868E99;
			font-size: 16px;

			&:hover {
				border: 1px solid @color2;
				color: @color2;
			}
		}

		.u-btn2 {
			width: 248px;
			height: 48px;
			background: linear-gradient(90deg, #FF5900 0%, #FFBE86 100%);
			border-radius: 10px;
			text-align: center;
			line-height: 48px;
			font-size: 16px;
			color: #fff;
			margin-left: 30px;
		}

		.user-right {
			flex: 1;
			width: 1px;
			margin-left: 30px;

			.u-form {
				.avatar {
					width: 60px;
					height: 60px;
					background: #FFFFFF;
					border-radius: 60px 60px 60px 60px;
					border: 1px solid #D8D8D8;
					overflow: hidden;
					position: relative;

					img {
						width: 100%;
						height: 100%;
					}

					.f {
						width: 100%;
						height: 100%;
						position: absolute;
						top: 0;
						left: 0;
						right: 0;
						bottom: 0;
						background-color: rgba(0, 0, 0, 0.6);
						display: flex;
						align-items: center;
						justify-content: center;
						text-align: center;

						img {
							width: 20px;
							height: 20px;
						}
					}

				}

				.rz {


					.rz0 {
						margin-left: 10px;
						color: @color2;
						font-size: 14px;
						line-height: 24px;
						height: 24px;
					}

					.rz1 {
						display: flex;
						align-items: center;
						justify-content: center;
						text-align: center;
						width: 74px;

						background: #F5F5F5;
						border-radius: 4px 4px 4px 4px;
						line-height: 24px;
						height: 24px;

						img {
							width: 20px;
							height: 20px;
						}

						span {
							margin-left: 5px;
							font-size: 14px;
							color: #BFBFBF;

						}
					}

					.rz2 {
						display: flex;
						align-items: center;
						justify-content: center;
						text-align: center;
						width: 74px;

						background: #FFF5EE;
						border-radius: 4px 4px 4px 4px;
						line-height: 24px;
						height: 24px;

						img {
							width: 20px;
							height: 20px;
						}

						span {
							margin-left: 5px;
							font-size: 14px;
							color: @color2;

						}
					}
				}
			}

			.u-title {

				height: 30px;
				line-height: 30px;
				font-weight: bold;
				font-size: 22px;
				color: #11192D;
				text-align: left;
				margin-bottom: 20px;
			}
		}
	}
</style>